import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import { NoSearchResults } from "~/components/NoSearchResults/NoSearchResults";
import { NoSearchResultsInfo } from "~/components/NoSearchResults/shared/NoSearchResultsInfo";
import { centralizedBoardTitleSelector } from "~/store/centralizedBoard/selectors";
export const PublicBoardNoSearchResults = ()=>{
    const currentBoardTitle = useSelector(centralizedBoardTitleSelector);
    return /*#__PURE__*/ _jsx(NoSearchResults, {
        location: currentBoardTitle,
        children: /*#__PURE__*/ _jsx(NoSearchResultsInfo, {
            children: "Check for typos or filters, or try a different search query."
        })
    });
};
